import tw, { styled } from 'twin.macro';

const TableRow = styled.tr`
  &:not(:last-of-type) {
    ${tw`border-0 border-gray-200 border-b border-solid `}
  }
  &:nth-of-type(odd) {
    ${props => (!props.active ? tw`bg-gray-100` : '')}
  }

  & th {
    ${tw`bg-white`}
  }

  ${({ theme, colour, active }) => `color: ${
    colour ? theme[colour] : theme.black
  };
  ${
    active &&
    `background-color: rgb(104 75 153 / 0.125); color: ${theme.primary}`
  }
  `}
`;

export default TableRow;
